import type { GetServerSideProps } from 'next';
import feature_spring_sale_2025 from '../../../public/images/feature_spring_sale_2025.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> =
  async (ctx) => {
    const { commonFeatureGetServerSideProps } = await import(
      '../../server/features/commonFeatureServerSideProps'
    );
    return commonFeatureGetServerSideProps(ctx);
  };

export default createFeatureNamePage({
  slug: 'springsale_2025',
  featureName: '新生活応援',
  title: '新生活応援セールメニュー一覧',
  description: 'あの占い師も特別価格で試せる！期間限定のセールメニュー特集',
  ogImageUrl: 'https://raysee.jp/images/feature_springsale_2025.png',
  heroImage: feature_spring_sale_2025,
});
